import { render, staticRenderFns } from "./TrademarkNoteList.vue?vue&type=template&id=c3b188ac&"
import script from "./TrademarkNoteList.vue?vue&type=script&lang=js&"
export * from "./TrademarkNoteList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkNoteList.vue?vue&type=style&index=0&id=c3b188ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports